import React, { useState, useEffect } from "react";
import Icon from "./Icon/Icon";
import WishlistIcon from "./Icon/WishlistIcon";
import FilledInWishlistIcon from "./Icon/FilledInWishlistIcon";

export default function Heart(props) {
    let ID = props.elem?.dataset?.id ? Number(props.elem.dataset.id) : props.id;
    let propsSelected = props.elem?.dataset?.selected
        ? props.elem.dataset.selected
        : props.selected;
    let propsType =
        (props.elem?.dataset?.type && props.elem?.dataset?.type) || props.type || "book";
    const wishlist = (props.elem?.dataset?.wishlist === "true") | props.wishlist;

    let [selected, setSelected] = useState(propsSelected);
    let [loading, setLoading] = useState(false);
    const loggedin = window.Dibook.loggedin ?? false;
    const isPurple = !!props.purple ?? false;

    function wishlistIncludes(wishlist, id) {
        let filteredItems = [];
        if (propsType === "book") {
            filteredItems = wishlist.items.filter((item) => item.id.toString() === id.toString());
        } else if (propsType === "series") {
            filteredItems = wishlist.series.filter(
                (item) => item.series_id.toString() === id.toString()
            );
        } else if (propsType === "reader") {
            filteredItems = wishlist.reader.filter(
                (item) => item.reader_id.toString() === id.toString()
            );
        } else if (propsType === "publisher") {
            filteredItems = wishlist.publisher.filter(
                (item) => item.publisher_id.toString() === id.toString()
            );
        } else if (propsType === "author") {
            filteredItems = wishlist.authors.filter(
                (item) => item.author_id.toString() === id.toString()
            );
        }

        return filteredItems.length > 0;
    }

    useEffect(() => {
        // Fetching whislist
        window.Dibook.wishlist
            .fetchWishlist()
            .then((payload) => {
                let data = payload.content?.data ?? [];
                if (data.items) {
                    setSelected(wishlistIncludes(data, ID));
                }
            })
            .catch((error) => console.log(error));

        let addingSubId = window.Dibook.wishlist.on("itemsAdding", (payload) => {
            if (!payload.preorder && payload.items.includes(ID)) setLoading(true);
        });

        let addedSubId = window.Dibook.wishlist.on("itemsAdded", (payload) => {
            setLoading(false);
            let items = payload.content?.data;

            if (items && !payload.preorder) {
                setSelected(wishlistIncludes(items, ID));
            }

            if (payload.status === 202) showLogin();
        });

        let removingSubId = window.Dibook.wishlist.on("itemsRemoving", (payload) => {
            if (!payload.preorder && payload.items.includes(ID)) setLoading(true);
        });

        let removedSubId = window.Dibook.wishlist.on("itemsRemoved", (payload) => {
            setLoading(false);
            let items = payload.content?.data;

            if (!payload.preorder && items) {
                setSelected(wishlistIncludes(items, ID));
            }

            if (payload.status === 202) showLogin();
        });

        return () => {
            window.Dibook.wishlist.off("itemsAdding", addingSubId);
            window.Dibook.wishlist.off("itemsAdded", addedSubId);
            window.Dibook.wishlist.off("itemsRemoving", removingSubId);
            window.Dibook.wishlist.off("itemsRemoved", removedSubId);
        };
    }, [ID]);

    const getTooltipText = () =>
        wishlist
            ? selected
                ? "Levétel a kívánságlistáról"
                : "Kívánságlistára"
            : selected
            ? "Kikedvencelés"
            : "Kedvencelés";

    useEffect(() => {
        $(`#widget-heart-${ID}`)
            .attr("data-original-title", getTooltipText())
            .tooltip("update")
            .tooltip();
    }, [ID, wishlist, selected]);

    return (
        <Wrapper {...props}>
            <div
                // title={getTooltipText()}
                title=""
                id={`widget-heart-${ID}`}
                data-toggle="tooltip"
                className={
                    "heart" +
                    (selected ? " selected" : "") +
                    (loading ? " loading" : "") +
                    (wishlist ? " d-flex align-items-center" : "")
                }
                onClick={(event) => handleHeartClick(event, ID)}
            >
                {wishlist ? selected ? <FilledInWishlistIcon /> : <WishlistIcon /> : <Icon isPurple={isPurple} />}
            </div>
        </Wrapper>
    );

    function handleHeartClick(e, id) {
        e.stopPropagation();
        if (!loggedin) return showLogin();

        if (loading) return;

        if (selected) {
            window.Dibook.wishlist.removeItems([id], propsType);
        } else {
            window.Dibook.wishlist.addItems([id], propsType);
        }
    }

    function showLogin() {
        window.$("#loginModal").modal("show");
    }
}

function Wrapper(props) {
    const wishlist = props.wishlist ? "true" : "false";

    if (props.elem?.className === "widget-heart") {
        return props.children;
    } else {
        return (
            <div
                className="widget-heart-component"
                data-wishlist={wishlist}
                style={props.style || {}}
            >
                {props.children}
            </div>
        );
    }
}
